const parseError = (err) => {
  if (err?.response?.data?.message) {
    return err.response.data.message;
  } else if (err?.response?.data?.status) {
    return err.response.data.status;
  } else if (err?.message) {
    return err.message;
  } else {
    return err;
  }
};

export default parseError;
